// extracted by mini-css-extract-plugin
export default {"defaultStar":"defaultStar__tqJnM5","defaultStarMarginLeft":"defaultStarMarginLeft__qpBQ8N"};